import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "bar", "count", "form", "toggleButton", "checkboxWrapper", "individualConfirm"]
  static values = { active: { type: Boolean, default: false } }

  toggle() {
    this.activeValue = !this.activeValue
  }

  activeValueChanged() {
    const active = this.activeValue
    const btn = this.toggleButtonTarget

    this.checkboxWrapperTargets.forEach(el => el.classList.toggle("hidden", !active))
    this.individualConfirmTargets.forEach(el => el.classList.toggle("hidden", active))
    btn.textContent = active ? btn.dataset.activeLabel : btn.dataset.inactiveLabel

    if (!active) {
      this.checkboxTargets.forEach(cb => { cb.checked = false })
      this.barTarget.classList.add("hidden")
    } else {
      this.updateBar()
    }
  }

  updateBar() {
    if (!this.activeValue) return
    const count = this.checkboxTargets.filter(cb => cb.checked).length
    this.barTarget.classList.toggle("hidden", count === 0)
    this.countTarget.textContent = count
  }

  submit() {
    const selected = this.checkboxTargets.filter(cb => cb.checked)
    if (selected.length === 0) return

    const form = this.formTarget
    form.querySelectorAll("input[name='user_ids[]']").forEach(el => el.remove())
    selected.forEach(cb => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "user_ids[]"
      input.value = cb.value
      form.appendChild(input)
    })
    form.requestSubmit()
  }
}
